import React from "react";
import { Controller } from "react-hook-form";
import { useTranslation } from "react-i18next";

function CustomInput({
  name,
  control,
  type,
  error,
  placeholder,
  onChange,
  className,
  autoComplete,
  inputMode,
  min,
  max,
  step,
  disabled = false,
  textarea = false,
  required = true,
  percentage = false,
  rules = {},
}) {
  const { t } = useTranslation();
  const inputClassName = `${className ?? "uk-input uk-border-rounded"}${
    error ? " uk-form-danger" : ""
  }`;
  const textareaClassName = `${className ?? "uk-textarea uk-border-rounded"}${
    error ? " uk-form-danger" : ""
  }`;
  const validationRules = {
    required: required && t("form.required"),
    ...(percentage
      ? {
          pattern: {
            value:
              /^((100((\.|,)[0-9]{1,2})?)|([0-9]{1,2}((\.|,)[0-9]{0,2})?))$/,
            message: t("form.invalidNumber"),
          },
          min: {
            value: 0,
            message: t("form.invalidNumber"),
          },
          max: {
            value: 100,
            message: t("form.invalidNumber"),
          },
        }
      : {}),
    ...rules,
  };

  return (
    <>
      <Controller
        name={name}
        control={control}
        render={({ field }) =>
          textarea ? (
            <textarea
              placeholder={placeholder ?? ""}
              className={textareaClassName}
              value={field.value ?? ""}
              disabled={disabled}
              onChange={(e) => {
                field.onChange(e.target.value);
                onChange && onChange(e.target.value);
              }}
              onBlur={field.onBlur}
              aria-invalid={error ? "true" : "false"}
            ></textarea>
          ) : (
            <input
              type={type ?? "text"}
              placeholder={placeholder ?? ""}
              className={inputClassName}
              value={field.value ?? ""}
              autoComplete={autoComplete}
              inputMode={inputMode}
              min={min}
              max={max}
              step={step}
              disabled={disabled}
              onChange={(e) => {
                field.onChange(
                  type === "number" && e.target.value != ""
                    ? parseFloat(e.target.value)
                    : e.target.value
                );
                onChange &&
                  onChange(
                    type === "number" && e.target.value !== ""
                      ? parseFloat(e.target.value)
                      : e.target.value
                  );
              }}
              onBlur={field.onBlur}
              aria-invalid={error ? "true" : "false"}
            />
          )
        }
        rules={validationRules}
      />
      {error && (
        <small className="uk-text-danger uk-display-block uk-margin-small-top">
          <span uk-icon="warning"></span>
          <span className="uk-margin-small-right uk-margin-small-left">
            {error.message}
          </span>
        </small>
      )}
    </>
  );
}

export default CustomInput;
